// import Vue from 'vue'
import consts from "@/consts"
import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = {'force[with_removed]': 1}//String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'updated_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _maintenanceServiceTasksIndexCache = {arr: null, map: null}
function getMaintenanceServiceTasksIndexMap(state) {
    if (_maintenanceServiceTasksIndexCache.arr !== state.maintenanceServiceTasks) {
        _maintenanceServiceTasksIndexCache.map = new Map(state.maintenanceServiceTasks.map((u, i) => [u.id, i]))
        _maintenanceServiceTasksIndexCache.arr = state.maintenanceServiceTasks
    }
    return _maintenanceServiceTasksIndexCache.map
}

export default {
    state: {
        maintenanceServiceTasksFullLoad: false,
        maintenanceServiceTasksLiteLoad: false,
        maintenanceServiceTasks: [],
    },
    actions: {
        fetchMaintenanceServiceTasks/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasks', args, time: Date.now() / 1000})

                const params = getApiProps('maintenance_service_tasks', args)
                this.$api.maintenanceservicetasks.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasks', args, inprogress: false})
                    });
            })
        },
        fetchMaintenanceServiceTasksAllInit({/*dispatch,*/ commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isMaintenanceServiceTasksLiteLoad) {
                    return resolve(getters.getMaintenanceServiceTasks.length)
                }
                this.$api.init.getMaintenanceServiceTasks()
                    .then((response) => {
                        if (response.status < 400 && response.data?.maintenance_service_tasks) {

                            commit('setMaintenanceServiceTasks', response.data.maintenance_service_tasks)
                            commit('setMaintenanceServiceTasksLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        //setTimeout(() => {
                        //    dispatch('fetchMaintenanceServiceTasksAllInit', {})
                        //}, 60 * 1000)
                    })
            })
        },
        fetchMaintenanceServiceTasksAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isMaintenanceServiceTasksLiteLoad) {
                    return resolve(getters.getMaintenanceServiceTasks.length)
                }
                dispatch('fetchMaintenanceServiceTasks', {lite: true})
                    .then((data) => {
                        commit('updateMaintenanceServiceTasks', data)
                        commit('setMaintenanceServiceTasksLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchMaintenanceServiceTasksAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchMaintenanceServiceTasksAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasksAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasksChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getMaintenanceServiceTasks.length) {
                        return resolve([])
                    }

                    let pageSize = consts.querySettings.maintenance.pageSize
                    let items = getters.getMaintenanceServiceTasks.length
                    let pages = Math.ceil( items / pageSize)
                    if(pages > 8) {
                        pageSize = Math.ceil(items / consts.querySettings.maxPages)
                        pages = Math.ceil(items / pageSize)
                    }
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchMaintenanceServiceTasks', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateMaintenanceServiceTasks', data)
                            })
                            .catch(() => {
                                dispatch('fetchMaintenanceServiceTasks', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            if (fetch.length) commit('setMaintenanceServiceTasksFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasksAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasksChanged', args, inprogress: false})
                })
        },
        fetchMaintenanceServiceTasksChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isMaintenanceServiceTasksFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasksChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchMaintenanceServiceTasks', args)
                .then((data) => {
                    commit('updateMaintenanceServiceTasks', data)
                    return dispatch('fetchMaintenanceServiceTasks', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterMaintenanceServiceTasks', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchMaintenanceServiceTasksChanged', args, inprogress: false})
                });
        },

        saveMaintenanceServiceTask({dispatch}, maintenanceServiceTask) {
            let fn = (maintenanceServiceTask.id) ? 'updateMaintenanceServiceTask' : 'createMaintenanceServiceTask'
            return dispatch(fn, maintenanceServiceTask);
        },
        createMaintenanceServiceTask({commit, dispatch}, maintenanceServiceTask) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_service_tasks')
                this.$api.maintenanceservicetasks.create(maintenanceServiceTask, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceServiceTask', response.data)
                            dispatch('fetchMaintenanceServiceTasksChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateMaintenanceServiceTask({commit, dispatch}, maintenanceServiceTask) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_service_tasks')
                this.$api.maintenanceservicetasks.update(maintenanceServiceTask.id, maintenanceServiceTask, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceServiceTask', response.data)
                            dispatch('fetchMaintenanceServiceTasksChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteMaintenanceServiceTask({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_service_tasks')
                this.$api.maintenanceservicetasks.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data.error)) {
                            if (!response.data) commit('deleteMaintenanceServiceTask', id)
                            else commit('updateMaintenanceServiceTask', response.data)
                            dispatch('fetchMaintenanceServiceTasksChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        removedMaintenanceServiceTask({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_service_tasks')
                this.$api.maintenanceservicetasks.removed(id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceServiceTask', response.data)
                            dispatch('fetchMaintenanceServiceTasksChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreMaintenanceServiceTask({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_service_tasks')
                this.$api.maintenanceservicetasks.restore(id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceServiceTask', response.data)
                            dispatch('fetchMaintenanceServiceTasksChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setMaintenanceServiceTasksFullLoad(state, FullLoad) {
            state.maintenanceServiceTasksFullLoad = state.maintenanceServiceTasksFullLoad || FullLoad
        },
        setMaintenanceServiceTasksLiteLoad(state, LitaLoad) {
            state.maintenanceServiceTasksLiteLoad = state.maintenanceServiceTasksLiteLoad || LitaLoad
        },

        setMaintenanceServiceTasks(state, nMaintenanceServiceTasks) {
            state.maintenanceServiceTasks = nMaintenanceServiceTasks
        },

        updateMaintenanceServiceTasks(state, nMaintenanceServiceTasks) {
            if (!state.maintenanceServiceTasks.length) {
                nMaintenanceServiceTasks = nMaintenanceServiceTasks.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nMaintenanceServiceTasks.sort(sortByName)
                state.maintenanceServiceTasks = nMaintenanceServiceTasks
                // const chunks = arraySplitIntoChunks(nMaintenanceServiceTasks)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.maintenanceServiceTasks.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            const indexById = getMaintenanceServiceTasksIndexMap(state)
            nMaintenanceServiceTasks.forEach(function (nMaintenanceServiceTask) {
                if (nMaintenanceServiceTask?.name) nMaintenanceServiceTask.name_ = nMaintenanceServiceTask.name.toLocaleLowerCase()
                let i = indexById.has(nMaintenanceServiceTask.id) ? indexById.get(nMaintenanceServiceTask.id) : -1
                if (i < 0) {
                    indexById.set(nMaintenanceServiceTask.id, state.maintenanceServiceTasks.length)
                    state.maintenanceServiceTasks.push(nMaintenanceServiceTask) //(Object.freeze(nMaintenanceServiceTask))
                } else
                if (!state.maintenanceServiceTasksFullLoad || state.maintenanceServiceTasks[i][changedField] != nMaintenanceServiceTask[changedField]) {
                    updateObjectByDiff(state.maintenanceServiceTasks[i], nMaintenanceServiceTask)
                    // delete nMaintenanceServiceTask.id
                    // nMaintenanceServiceTask = {...state.maintenanceServiceTasks[i], ...nMaintenanceServiceTask}
                    // state.maintenanceServiceTasks[i] = nMaintenanceServiceTask //Object.freeze(nMaintenanceServiceTask)
                }
            })

        },
        filterMaintenanceServiceTasks(state, nMaintenanceServiceTasks) {
            // let Ids = state.maintenanceServiceTasks.map(u=> u.id)
            let nIds = new Set(nMaintenanceServiceTasks.map(u => u.id))
            state.maintenanceServiceTasks = state.maintenanceServiceTasks.filter(u => nIds.has(u.id))
        },
        updateMaintenanceServiceTask(state, nMaintenanceServiceTask) {
            if (nMaintenanceServiceTask?.name) nMaintenanceServiceTask.name_ = nMaintenanceServiceTask.name.toLocaleLowerCase()
            let i = state.maintenanceServiceTasks.findIndex(u => (u.id == nMaintenanceServiceTask.id))
            if (i < 0) {
                state.maintenanceServiceTasks.push(nMaintenanceServiceTask) //(Object.freeze(nMaintenanceServiceTask))
            } else
            if (!state.maintenanceServiceTasksFullLoad || state.maintenanceServiceTasks[i][changedField] != nMaintenanceServiceTask[changedField]) {
                updateObjectByDiff(state.maintenanceServiceTasks[i], nMaintenanceServiceTask)
                // delete nMaintenanceServiceTask.id
                // nMaintenanceServiceTask = {...state.maintenanceServiceTasks[i], ...nMaintenanceServiceTask}
                // state.maintenanceServiceTasks[i] = nMaintenanceServiceTask //Object.freeze(nMaintenanceServiceTask)
            }
        },
        deleteMaintenanceServiceTask(state, id) {
            let i = state.maintenanceServiceTasks.findIndex(u => (u.id == id))
            if (i != -1) {
                state.maintenanceServiceTasks.splice(i, 1)
            }
        },

        clearMaintenanceServiceTasks(state) {
            state.maintenanceServiceTasks = []
            state.maintenanceServiceTasksFullLoad = false
            state.maintenanceServiceTasksLiteLoad = false
        },
    },
    getters: {
        isMaintenanceServiceTasksFullLoad(state) {
            return state.maintenanceServiceTasksFullLoad
        },
        isMaintenanceServiceTasksLiteLoad(state) {
            return state.maintenanceServiceTasksLiteLoad
        },
        getMaintenanceServiceTasks(state) {
            return state.maintenanceServiceTasks
        },
        getMaintenanceServiceTasksByIds(state) {
            return state.maintenanceServiceTasks.reduce((maintenanceServiceTasksByIds, maintenanceServiceTask) => {
                maintenanceServiceTasksByIds[maintenanceServiceTask.id] = maintenanceServiceTask
                return maintenanceServiceTasksByIds
            }, {})
        },
        getSortedMaintenanceServiceTasksIds(state) {
            let maintenanceServiceTasks = state.maintenanceServiceTasks
            maintenanceServiceTasks.sort(sortByName)
            return maintenanceServiceTasks.map(u => u.id)
        },
    }
}
